import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,
  resetSuccessMsg: null,
  resetError: null,
  userEmail: "",
  isForgetError: false
};

const forgotPasswordSlice = createSlice({
  name: "forgotpwd",
  initialState,
  reducers: {
    userForgetPasswordSuccess(state, action) {
      state.forgetSuccessMsg = action.payload.message;
      state.userEmail = action.payload.email;
      state.isForgetError = false
    },
    userForgetPasswordError(state, action) {
      state.forgetError = action.payload;
      state.isForgetError = true
    },
    userResetPasswordSuccess(state, action) {
      state.resetSuccessMsg = action.payload;
      state.isForgetError = false
    },
    userResetPasswordError(state, action) {
      state.resetError = action.payload;
      state.isForgetError = true
    },
    resetForgetPasswordFlag(state) {
      state.forgetSuccessMsg = null;
      state.forgetError = null;
    },
    resetResetPasswordFlag(state) {
      state.resetSuccessMsg = null;
      state.resetError = null;
      state.isForgetError = false
    },
  },
});

export const {
  userForgetPasswordSuccess,
  userForgetPasswordError,
  userResetPasswordSuccess,
  userResetPasswordError,
  resetForgetPasswordFlag,
  resetResetPasswordFlag,
} = forgotPasswordSlice.actions;

export default forgotPasswordSlice.reducer;
